import { render, staticRenderFns } from "./PlayerStregthWidget.vue?vue&type=template&id=239451a4&"
import script from "./PlayerStregthWidget.vue?vue&type=script&lang=js&"
export * from "./PlayerStregthWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports